import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-slider"
    }}>{`sp-slider`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a slider with optional associated label.`}</p>
    <p><img alt="Sliders" src={require("../../assets/sp-slider.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/slider/"
        }}>{`https://spectrum.adobe.com/page/slider/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/slider"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/slider`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-slider min="0" max="100" value="50">
    <sp-label slot="label">Slider Label</sp-label>
</sp-slider>
`}</code></pre>
    <h2 {...{
      "id": "variants-and-states"
    }}>{`Variants and states`}</h2>
    <p>{`There are several different variants for sliders.`}</p>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <p>{`Indicates that the slider is disabled.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-slider disabled min="0" max="100" value="50"></sp-slider>
`}</code></pre>
    <h3 {...{
      "id": "filled"
    }}>{`Filled`}</h3>
    <p>{`Fills one side of the slider track. Which side is specified with `}<inlineCode parentName="p">{`fill-offset`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-slider variant="filled" fill-offset="left" min="0" max="100" value="50"></sp-slider>
<sp-slider variant="filled" fill-offset="right" min="0" max="100" value="50"></sp-slider>
`}</code></pre>
    <h3 {...{
      "id": "custom-unit"
    }}>{`Custom unit`}</h3>
    <p>{`You can specify a custom unit for the slider value -- such as "%".`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-slider value-label="%" min="0" max="100" value="50"></sp-slider>
`}</code></pre>
    <h3 {...{
      "id": "hiding-the-value"
    }}>{`Hiding the value`}</h3>
    <p>{`You can hide the slider value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-slider show-value="false" min="0" max="100" value="50"></sp-slider>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes on the slider using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` and `}<inlineCode parentName="p">{`input`}</inlineCode>{` events.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourSlider").addEventListener("input", evt => {
    console.log(\`New value: \${evt.target.value}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      